module.exports = __webpack_public_path__ + "static/media/insect(11).37207075.PNG";